import { gql } from '@apollo/client';

export const FULL_BLOG_ARTICLE = gql`
  fragment FullFragmentArticle on BlogArticle {
    _id
    photoName
    title
    content
    createdAt
    photoUrl
    description
    __typename
  }
`;

export const PARTIAL_BLOG_ARTICLE = gql`
  fragment PartialFragmentArticle on BlogArticle {
    _id
    title
    createdAt
    __typename
  }
`;
